import { EventMap, WrappedEvent } from '@drift-labs/sdk';
import React, {
	PropsWithChildren,
	useContext,
	useEffect,
	useState,
} from 'react';
import { Subject } from 'rxjs';
import { DriftBlockchainEventSubscriberContext } from './driftBlockchainEventSubscriberProvider';

/**
 * This provider is responsible for creating the subjects that the drift events can be piped into.
 */

type DriftBlockchainEventSubjectContextType = {
	userEventSubject: Subject<WrappedEvent<keyof EventMap>>;
	globalOrderActionEventSubject: Subject<WrappedEvent<'OrderActionRecord'>>;
};

const INITIAL_CONTEXT_VALUE: DriftBlockchainEventSubjectContextType = {
	userEventSubject: undefined,
	globalOrderActionEventSubject: undefined,
};

/**
 * userEventSubscriber: EventSubscriber for the current user's events
 * globalOrderActionEventSubscriber: EventSubscriber for market-wide order action events
 */
export const DriftBlockchainEventSubjectContext =
	React.createContext<DriftBlockchainEventSubjectContextType>(
		INITIAL_CONTEXT_VALUE
	);

export const DriftBlockchainEventSubjectProvider = (
	props: PropsWithChildren<any>
) => {
	const eventSubscriberContext = useContext(
		DriftBlockchainEventSubscriberContext
	);
	const [contextValue, setContextValue] =
		useState<DriftBlockchainEventSubjectContextType>(INITIAL_CONTEXT_VALUE);

	useEffect(() => {
		const userEventSubject = new Subject<WrappedEvent<keyof EventMap>>();
		const globalOrderActionEventSubject = new Subject<
			WrappedEvent<'OrderActionRecord'>
		>();

		setContextValue({
			userEventSubject,
			globalOrderActionEventSubject,
		});
	}, [eventSubscriberContext]);

	return (
		<DriftBlockchainEventSubjectContext.Provider value={contextValue}>
			{props.children}
		</DriftBlockchainEventSubjectContext.Provider>
	);
};
